import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../service/app.service';
import { RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { PublicBrandingService } from '../service/public-branding.service';

const LOADER_MIN_MS = 500;
/** Never hold the app behind a slow logo lookup longer than this. */
const LOADER_MAX_MS = 1500;
const DEFAULT_LOGO = '/assets/images/logo.svg';

@Component({
    selector: 'app-root',
    templateUrl: './auth-layout.html',
    standalone: true,
    imports: [
        NgClass,
        RouterOutlet,
    ],
})
export class AuthLayout implements OnInit, OnDestroy {
    private readonly service = inject(AppService);
    readonly store = this.service.indexState;
    private readonly publicBranding = inject(PublicBrandingService);
    private brokenLoaderLogo: string | null = null;

    /** False until the logo lookup settles (or times out), so the loader never flashes the wrong brand first. */
    logoSettled = false;

    /** The tenant's logo once the public lookup has it; the product mark until then or if it will not load. */
    get loaderLogo(): string {
        const logo = this.publicBranding.logo();
        return logo && logo !== this.brokenLoaderLogo ? logo : DEFAULT_LOGO;
    }

    onLoaderLogoError(): void {
        this.brokenLoaderLogo = this.publicBranding.logo();
    }

    showTopButton = false;
    constructor(public storeData: Store<any>) {}
    headerClass = '';
    ngOnInit() {
        this.toggleLoader();
        window.addEventListener('scroll', () => {
            if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
                this.showTopButton = true;
            } else {
                this.showTopButton = false;
            }
        });
    }

    toggleLoader() {
        this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
        this.publicBranding.load();
        // Keep the loader up just long enough for the tenant logo to arrive, so the first thing a
        // customer sees is their bank's mark rather than a flash of the product logo.
        const minimum = new Promise<void>((resolve) => setTimeout(resolve, LOADER_MIN_MS));
        const cap = new Promise<void>((resolve) => setTimeout(resolve, LOADER_MAX_MS));
        const logoKnown = Promise.race([this.publicBranding.ready, cap]).then(() => {
            this.logoSettled = true;
        });
        void Promise.all([minimum, logoKnown]).then(() => {
            this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
        });
    }

    ngOnDestroy() {
        window.removeEventListener('scroll', () => {});
    }

    goToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}
